/*
Author: Liubo
Date: 2018-09-05
Desc: Vue 路由配置
*/
import Vue from "vue";
import Router from "vue-router";
import util from "@/util";

Vue.use(Router);
export default new Router({
    // mode: "history",
    base: process.env.BASE_URL,
    routes: [{
        path: "/",
        name: "login",
        meta: { requiresAuth: false, nameText: "登录" },
        component: () =>
                import ( /* webpackChunkName: "login" */ "./views/common/login.vue")
    },
    // 路由错误跳转到首页
    {
        path: "*",
        redirect: "/"
    },
    {
        path: "/frame",
        name: "frame",
        meta: { requiresAuth: true, nameText: "顶层frame" },
        component: () =>
                import ( /* webpackChunkName: "frame" */ "./views/common/frame.vue"),
        children: [
            //首页
            {
                path: "/org/home",
                name: "home",
                meta: {
                    requiresAuth: true,
                    nameText: "我的资产",
                    requiresCheck: { func: util.checkAcct, params: { checkCate: "2" } }
                }, // 检查用户信息 1用户是否绑定交易账户，2用户必须完善信息，3用户交易必须完善信息
                component: () =>
                        import ( /* webpackChunkName: "orginfo" */ "./views/common/dynaView.vue")
            },
            // 高端理财-私募、专户理财基金
            {
                path: "/private",
                name: "private",
                meta: {
                    requiresAuth: true,
                    nameText: "专户/私募基金",
                    requiresCheck: { func: util.checkAcct, params: { checkCate: "2" } }
                },
                component: () =>
                        import ( /* webpackChunkName: "private" */ "./views/common/dynaView.vue")
            },
            {
                path: "/privatefund/privatebuy",
                name: "privatebuy",
                meta: {
                    requiresAuth: true,
                    nameText: "专户/私募基金购买",
                    requiresCheck: {
                        func: util.checkAcct,
                        params: { checkCate: "1,2,3" }
                    }
                },
                component: () =>
                        import ( /* webpackChunkName: "privatebuy" */ "./views/common/dynaView.vue")
            },
            {
                path: "/privatefund",
                name: "privatefund",
                meta: { requiresAuth: true,
                    nameText: "持有专户/私募基金" ,
                    requiresCheck: { func: util.checkAcct, params: { checkCate: "2" } }
                },
                component: () =>
                        import ( /* webpackChunkName: "privatefund" */ "./views/common/dynaView.vue")
            },
            {
                path: "/info/bindtransactor",
                name: "bindtransactor",
                meta: {
                    requiresAuth: true,
                    nameText: "绑定经办人",
                    requiresCheck: { func: util.checkAcct, params: { checkCate: "1" } }
                },
                component: () =>
                    import ( /* webpackChunkName: "bindtransactor" */ "./views/common/dynaView.vue")
            },
            {
                path: "/info/checkacct",
                name: "checkacct",
                meta: {
                    requiresAuth: true,
                    nameText: "完善用户信息",
                    requiresCheck: { func: util.checkAcct, params: { checkCate: "1" } }
                },
                component: () =>
                    import ( /* webpackChunkName: "checkacct" */ "./views/common/dynaView.vue")
            },
            // 用户信息
            {
                path: "/orginfo",
                name: "orginfo",
                meta: {
                    requiresAuth: true,
                    nameText: "机构账户信息",
                    requiresCheck: { func: util.checkAcct, params: { checkCate: "1,2" } }
                },
                component: () =>
                        import ( /* webpackChunkName: "orginfo" */ "./views/common/dynaView.vue")
            },
            {
                path: "/orginfo/modifyinfo",
                name: "modifyinfo",
                meta: {
                    requiresAuth: true,
                    nameText: "修改机构用户信息",
                    requiresCheck: { func: util.checkAcct, params: { checkCate: "1" } }
                },
                component: () =>
                            import ( /* webpackChunkName: "modifyinfo" */ "./views/common/dynaView.vue")
            },
            {
                path: "/orginfo/changetpwd",
                name: "changetpwd",
                meta: {
                    requiresAuth: true,
                    nameText: "交易密码修改",
                    requiresCheck: { func: util.checkAcct, params: { checkCate: "1" } }
                },
                component: () =>
                            import ( /* webpackChunkName: "changetpwd" */ "./views/common/dynaView.vue")
            },
            {
                path: "/orginfo/changelpwd",
                name: "changelpwd",
                meta: {
                    requiresAuth: true,
                    nameText: "登陆密码修改",
                    requiresCheck: { func: util.checkAcct, params: { checkCate: "1" } }
                },
                component: () =>
                            import ( /* webpackChunkName: "changetpwd" */ "./views/common/dynaView.vue")
            },
            {
                path: "/orginfo/infocollection",
                name: "infocollection",
                meta: {
                    requiresAuth: true,
                    nameText: "投资者信息补录",
                    requiresCheck: { func: util.checkAcct, params: { checkCate: "1" } }
                },
                component: () =>
                            import ( /* webpackChunkName: "infocollection" */ "./views/common/dynaView.vue")
            },
            {
                path: "/orginfo/taxeslist",
                name: "taxeslist",
                meta: {
                    requiresAuth: true,
                    nameText: "税收信息列表",
                    requiresCheck: { func: util.checkAcct, params: { checkCate: "1" } }
                },
                component: () =>
                            import ( /* webpackChunkName: "taxeslist" */ "./views/common/dynaView.vue")
            },
            {
                path: "/orginfo/taxesinfo",
                name: "taxesinfo",
                meta: {
                    requiresAuth: true,
                    nameText: "税收信息",
                    requiresCheck: { func: util.checkAcct, params: { checkCate: "1" } }
                },
                component: () =>
                            import ( /* webpackChunkName: "taxesinfo" */ "./views/common/dynaView.vue")
            },
            {
                path: "/orginfo/invchange",
                name: "invchange",
                meta: {
                    requiresAuth: true,
                    nameText: "投资者转换",
                    requiresCheck: {
                        func: util.checkAcct,
                        params: { checkCate: "1,2" }
                    }
                },
                component: () =>
                            import ( /* webpackChunkName: "invchange" */ "./views/common/dynaView.vue")
            },
            {
                path: "/orginfo/invknowledgetest",
                name: "invknowledgetest",
                meta: {
                    requiresAuth: true,
                    nameText: "投资者知识评测",
                    requiresCheck: {
                        func: util.checkAcct,
                        params: { checkCate: "1" }
                    }
                },
                component: () =>
                            import ( /* webpackChunkName: "invknowledgetest" */ "./views/common/dynaView.vue")
            },
            {
                path: "/orginfo/invdataup",
                name: "invdataup",
                meta: {
                    requiresAuth: true,
                    nameText: "投资者文件上传",
                    requiresCheck: {
                        func: util.checkAcct,
                        params: { checkCate: "1,2" }
                    }
                },
                component: () =>
                            import ( /* webpackChunkName: "invdataup" */ "./views/common/dynaView.vue")
            },
            {
                path: "/orginfo/beneficiarylist",
                name: "beneficiarylist",
                meta: {
                    requiresAuth: true,
                    nameText: "受益人信息",
                    requiresCheck: {
                        func: util.checkAcct,
                        params: { checkCate: "1,2" }
                    }
                },
                component: () =>
                            import ( /* webpackChunkName: "beneficiarylist" */ "./views/common/dynaView.vue")
            },
            {
                path: "/orginfo/beneficiaryinfo",
                name: "beneficiaryinfo",
                meta: {
                    requiresAuth: true,
                    nameText: "受益人信息",
                    requiresCheck: {
                        func: util.checkAcct,
                        params: { checkCate: "1,2" }
                    }
                },
                component: () =>
                            import ( /* webpackChunkName: "beneficiaryinfo" */ "./views/common/dynaView.vue")
            },
            {
                path: "/orginfo/controllist",
                name: "controllist",
                meta: {
                    requiresAuth: true,
                    nameText: "控制人信息",
                    requiresCheck: {
                        func: util.checkAcct,
                        params: { checkCate: "1,2" }
                    }
                },
                component: () =>
                            import ( /* webpackChunkName: "controllist" */ "./views/common/dynaView.vue")
            },
            {
                path: "/orginfo/controlinfo",
                name: "controlinfo",
                meta: {
                    requiresAuth: true,
                    nameText: "控制人信息",
                    requiresCheck: {
                        func: util.checkAcct,
                        params: { checkCate: "1,2" }
                    }
                },
                component: () =>
                            import ( /* webpackChunkName: "controlinfo" */ "./views/common/dynaView.vue")
            },
            {
                path: "/orginfo/risk",
                name: "risk",
                meta: {
                    requiresAuth: true,
                    nameText: "风险信息",
                    requiresCheck: { func: util.checkAcct, params: { checkCate: "1" } }
                },
                component: () =>
                            import ( /* webpackChunkName: "risk" */ "./views/common/dynaView.vue")
            },
            {
                path: "/orginfo/risktest",
                name: "risktest",
                meta: {
                    requiresAuth: true,
                    nameText: "风险评测",
                    requiresCheck: { func: util.checkAcct, params: { checkCate: "1" } }
                },
                component: () =>
                            import ( /* webpackChunkName: "risktest" */ "./views/common/dynaView.vue")
            },
            // 基金信息
            {
                path: "/fund",
                name: "fund",
                meta: {
                    requiresAuth: true,
                    nameText: "基金列表",
                    requiresCheck: { func: util.checkAcct, params: { checkCate: "2" } }
                },
                component: () =>
                    import ( /* webpackChunkName: "fund" */ "./views/common/dynaView.vue")
            },
            {
                path: "/fund/buyfund",
                name: "buyfund",
                meta: {
                    requiresAuth: true,
                    nameText: "买基金",
                    requiresCheck: {
                        func: util.checkAcct,
                        params: { checkCate: "2" }
                    }
                },
                component: () =>
                    import ( /* webpackChunkName: "buyfund" */ "./views/common/dynaView.vue")
            },
            {
                path: "/fund/sellfund",
                name: "sellfund",
                meta: {
                    requiresAuth: true,
                    nameText: "基金赎回",
                    requiresCheck: {
                        func: util.checkAcct,
                        params: { checkCate: "1" }
                    }
                },
                component: () =>
                    import ( /* webpackChunkName: "sellfund" */ "./views/common/dynaView.vue")
            },
            {
                path: "/cfund",
                name: "cfund",
                meta: {
                    requiresAuth: true,
                    nameText: "基金转换列表",
                    requiresCheck: { func: util.checkAcct, params: { checkCate: "1" } }
                },
                component: () =>
                    import ( /* webpackChunkName: "cfund" */ "./views/common/dynaView.vue")
            },
            {
                path: "/fund/changefund",
                name: "changefund",
                meta: {
                    requiresAuth: true,
                    nameText: "基金转换",
                    requiresCheck: {
                        func: util.checkAcct,
                        params: { checkCate: "1" }
                    }
                },
                component: () =>
                    import ( /* webpackChunkName: "changefund" */ "./views/common/dynaView.vue")
            },
            /* 交易记录 */
            {
                path: "/traderecord",
                name: "traderecord",
                meta: {
                    requiresAuth: true,
                    nameText: "交易记录"
                    ,
                    requiresCheck: { func: util.checkAcct, params: { checkCate: "2" } }
                },
                component: () =>
                        import ( /* webpackChunkName: "traderecord" */ "./views/common/dynaView.vue")
            },
            /* 账户申请查询 */
            /*{
                path: "/acctApplication",
                name: "acctApplication",
                meta: {
                    requiresAuth: true,
                    nameText: "账户申请查询"
                    ,
                    requiresCheck: { func: util.checkAcct, params: { checkCate: "1,2" } }
                },
                component: () =>
                        import ( /!* webpackChunkName: "acctApplication" *!/ "./views/common/dynaView.vue")
            },*/
            /* 信息披露 */
            {
                path: "/infoPublish",
                name: "infoPublish",
                meta: {
                    requiresAuth: true,
                    nameText: "信息披露"
                    ,
                    requiresCheck: { func: util.checkAcct, params: { checkCate: "2" } }
                },
                component: () =>
                        import ( /* webpackChunkName: "infoPublish" */ "./views/common/dynaView.vue")
            },
            /* 公告详情 */
            {
                path: "/knowdetail",
                name: "knowdetail",
                meta: {
                    requiresAuth: true,
                    nameText: "公告详情"
                    ,
                    requiresCheck: { func: util.checkAcct, params: { checkCate: "2" } }
                },
                component: () =>
                        import ( /* webpackChunkName: "knowdetail" */ "./views/common/dynaView.vue")
            },
            {
                path: "/policyAndLaw",
                name: "policyAndLaw",
                meta: {
                    requiresAuth: true,
                    nameText: "政策法规",
                    requiresCheck: {func: util.checkAcct, params: {checkCate: "1"}}
                },
                component: () =>
                    import ( /* webpackChunkName: "policyAndLaw" */ "./views/common/dynaView.vue")
            },
            /* 汇款信息 */
            {
                path: "/remitinfo",
                name: "remitinfo",
                meta: {
                    requiresAuth: true,
                    nameText: "汇款信息"
                    ,
                    requiresCheck: { func: util.checkAcct, params: { checkCate: "2" } }
                },
                component: () =>
                        import ( /* webpackChunkName: "remitinfo" */ "./views/common/dynaView.vue")
            },
            // 对账单信息
            {
                path: "/statement",
                name: "statement",
                meta: {
                    requiresAuth: true,
                    nameText: "对账单信息"
                },
                component: () =>
                        import ( /* webpackChunkName: "statement" */ "./views/common/dynaView.vue")
            },
            /* 分红查询 */
            {
                path: "/dividend",
                name: "dividend",
                meta: {
                    requiresAuth: true,
                    nameText: "分红查询"
                    ,
                    requiresCheck: { func: util.checkAcct, params: { checkCate: "2" } }
                },
                component: () =>
                        import ( /* webpackChunkName: "dividend" */ "./views/common/dynaView.vue")
            }
        ]
    },
    {
        path: "/outframe",
        name: "outframe",
        redirect: "/regresult",
        meta: { requiresAuth: false, nameText: "外层frame" },
        component: () =>
                import ( /* webpackChunkName: "outframe" */ "./views/common/outFrame.vue"),
        children: [{
            path: "/outframe/errGeneral",
            name: "errgeneral",
            meta: { requiresAuth: false, nameText: "系统错误" },
            component: () =>
                        import ( /* webpackChunkName: "errgeneral" */ "./views/common/errGeneral.vue")
        },{
            path: "/outframe/errNetwork",
            name: "errnetwork",
            meta: { requiresAuth: false, nameText: "网络错误" },
            component: () =>
                        import ( /* webpackChunkName: "errnetwork" */ "./views/common/errNetwork.vue")
        },{
            path: "/outframe/openinfo",
            name: "openinfo",
            meta: { requiresAuth: false, nameText: "开户须知" },
            component: () =>
                import ( /* webpackChunkName: "errnetwork" */ "./views/common/dynaView.vue")
        },{
            path: "/outframe/agentinfo",
            name: "agentinfo",
            meta: { requiresAuth: false, nameText: "经办人信息" },
            component: () =>
                import ( /* webpackChunkName: "errnetwork" */ "./views/common/dynaView.vue")
        },{
            path: "/outframe/orgtype",
            name: "orgtype",
            meta: { requiresAuth: false, nameText: "机构类型" },
            component: () =>
                import ( /* webpackChunkName: "errnetwork" */ "./views/common/dynaView.vue")
        },{
            path: "/outframe/basicinfo",
            name: "basicinfo",
            meta: { requiresAuth: false, nameText: "基本信息" },
            component: () =>
                import ( /* webpackChunkName: "errnetwork" */ "./views/common/dynaView.vue")
        },{
            path: "/outframe/orgregister",
            name: "orgregister",
            meta: { requiresAuth: false, nameText: "信息登记" },
            component: () =>
                import ( /* webpackChunkName: "errnetwork" */ "./views/common/dynaView.vue")
        },{
            path: "/outframe/bankinfo",
            name: "bankinfo",
            meta: { requiresAuth: false, nameText: "银行信息" },
            component: () =>
                import ( /* webpackChunkName: "errnetwork" */ "./views/common/dynaView.vue")
        },{
            path: "/outframe/opensuccess",
            name: "opensuccess",
            meta: { requiresAuth: false, nameText: "完成注册" },
            component: () =>
                import ( /* webpackChunkName: "errnetwork" */ "./views/common/dynaView.vue")
        },{
            path: "/outframe/upload",
            name: "uploadfile",
            meta: { requiresAuth: false, nameText: "文件上传" },
            component: () =>
                import ( /* webpackChunkName: "errnetwork" */ "./views/common/dynaView.vue")
        }]
    }
    ]
});
